module.exports = __webpack_public_path__ + "img/box_TOEIC7_describe.1d51a39b.svg";